export default "__VITE_ASSET__BbmHOlif__"